import { render, staticRenderFns } from "./SidePanelNeedsFilters.vue?vue&type=template&id=3b29cdee&scoped=true&"
import script from "./SidePanelNeedsFilters.vue?vue&type=script&lang=js&"
export * from "./SidePanelNeedsFilters.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelNeedsFilters.vue?vue&type=style&index=0&id=3b29cdee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b29cdee",
  null
  
)

export default component.exports